class DEFAULTS {
  BUSINESS = {
    generalSettings: {
      enableHumanAssistance: false,
      liveAgentChatTool: '',
      enableSmallTalk: true,
      requestsPii: false,
      activeBots: [],
      defaultBot: '',
      fallbackBot: '',
      businessName: '',
      businessViaName: '',
      previewText: '',
      order: 999,
      activePartners: [],
      collectFeedback: false,
      collectFeedbackMultiple: false,
      collectFeedbackDelay: 30,
      languageCode: 'en',
      pipelineVersion: '1',
    },
    partnerSpecificSettings: {
      taskboxHeader: 'Hey! How can I help you?',
      allTasks: [],
    },
    botPromptTriggerSettings: [],
  };

  SDK_CONFIG = {
    businessIcon: '',
    businessActive: true,
    showHaptikBranding: true,
    primaryColor: '#2DACF0',
    widgetPositioning: 'bottom-right',
    mode: 'ssm',
    botType: 'TEXT',
    disabled: [],
    chatIconConfig: {
      type: 'default',
      data: {
        imageURL: ''
      },
    },
    headerText: 'Haptik',
    buttonText: "Let's Chat!",
    buttonTextDesktop: "Let's Chat!",
    buttonTextMobile: "Let's Chat!",
    fontFamily: 'Roboto',
    fontSize: '14px',
    composerPlaceholder: 'Type here...',
    customSignup: false,
    customSignupIdentifier: 'guest',
    baseUrl: 'https://staging.hellohaptik.com',
    customButton: false,
    customButtonIdentifier: '',
    voiceBotInitialInput: 'VOICE',
    gdpr: false,
    enableTypingSuggestions: false,
    showUserFeedback: false,
    userFeedbackTagsPositive: [],
    userFeedbackTagsNegative: [],
    userFeedbackQuestionPositive: '',
    userFeedbackQuestionNegative: '',
  };

  PARTNER_SETTINGS = {
    botBreakMessage: ["I'm sorry, I didn't understand that!"],
    outlierMessage: ["I'm sorry, I didn't understand that!"],
    taskboxSettings: { tasks: {} },
    sdkConfiguration: this.SDK_CONFIG,
    platformDeployments: {},
  };

  TASK = {
    name: '',
    message: '',
    location_required: false,
    is_tasklist_supported: false,
    is_taskbox_supported: false,
  };
}

export default new DEFAULTS();
